type Notification = {
  notificationId?: string;
  createdDate?: string;
};

type Notification72hConfig = {
  deliveredKey: string;   // e.g. "allOrdersDelivered"
  closedKey: string;      // e.g. "ordersClosed"
};

export const createNotification72hContext = (
  notifications: Notification[] = [],
  config: Notification72hConfig
) => {
  const deliveredMap = new Map<string, string>();
  const closedOrders = new Set<string>();
  const missingNotificationOrders: string[] = [];

  const isWithin72Hours = (dateString: string) => {
    if (!dateString) return false;
    const diffMs = Date.now() - new Date(dateString).getTime();
    return diffMs <= 72 * 60 * 60 * 1000;
  };

  notifications.forEach((n) => {
    const id = n?.notificationId || "";

    // DELIVERY / VIEW EVENT
    if (id.includes(config.deliveredKey)) {
      const orderNumber = id.replace(config.deliveredKey, "");

      if (!deliveredMap.has(orderNumber)) {
        deliveredMap.set(orderNumber, n.createdDate || "");
      }
    }

    // CLOSE EVENT
    if (id.includes(config.closedKey)) {
      const orderNumber = id.replace(config.closedKey, "");
      closedOrders.add(orderNumber);
    }
  });

  return {
    deliveredMap,
    closedOrders,
    missingNotificationOrders,
    isWithin72Hours,
  };
};